import { Box, Typography } from '@mui/material'
import { sectionHeadingSx } from '../../theme/mobileLayout'

function StatCard({ value, label }) {
  return (
    <Box
      sx={{
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 32, md: 40, lg: 40 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
          }}
        >
          {value}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 20, md: 24, lg: 24 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  )
}

export default function ProgramStatsSection({ title, stats = [] }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 5, md: '80px' }, width: '100%' }}>
      <Typography
        component="h2"
        sx={sectionHeadingSx}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: '1fr 1fr',
            lg: 'repeat(4, 1fr)',
          },
          gap: '40px',
          width: '100%',
        }}
      >
        {stats.map((stat) => (
          <StatCard key={stat.label} {...stat} />
        ))}
      </Box>
    </Box>
  )
}
